<template>
    <transition name="fade">
        <v-flex class="vh-100" direction="column" v-if="loaded">
            <header
                class="header d-flex align-items-center justify-content-center bg-dark text-white flex-shrink-0"
                ref="header"
            >
                <div id="background" ref="background">
                    <div
                        :key="row"
                        :style="`left: -${(row - 1) * 120}px`"
                        class="bg-row"
                        v-for="row in rows"
                    >
                        <b :key="phrase" v-for="phrase in phrases">
                            HEY
                            <span>COACH</span>
                        </b>
                    </div>
                </div>
                <div v-if="invite.coach" class="text-center" id="header-content">
                    <div class="text-center text-dark mb-3 logo-circle mx-auto">
                        <Logo />
                    </div>
                    <div class="text-center">
                        <b>COACH</b>
                    </div>
                    <h1 class="text-center coach-name">
                        {{ invite.coach.account.first_name }}
                    </h1>
                </div>
                <div class="header-shadow"></div>
            </header>
            <transition mode="out-in" name="fade">
                <router-view
                    :invite="invite"
                    class="flex-grow-1"
                    v-if="invite"
                />
            </transition>
            <ladder-footer class="border-top" />
        </v-flex>
    </transition>
</template>

<script>
import store from "@/store";
import Logo from "@/components/Logo";
import LadderFooter from "@/components/LadderFooter";

export default {
    name: "InviteLayout",
    components: {
        Logo,
        LadderFooter
    },
    props: {
        token: {
            default: null
        }
    },
    data() {
        return {
            loaded: false,
            rows: 15,
            phrases: 200,
            offer: null
        };
    },
    computed: {
        invite() {
            if (!this.offer.id) {
                return {};
            }
            let invite = { ...this.offer };

            // If there are trial days, build a string
            if (invite.trial_days) {
                invite.trial_string = invite.trial_days + " days";
            }

            // If the invite cost doesn't have cents, don't show them

            if (invite.price.includes(".00")) {
                invite.price_string = invite.price.split(".")[0]
            }
            // Grab their first and last name (if exists)
            let name = invite.full_name ? invite.full_name.split(' ') : []
            invite.first_name = name[0] ? name[0] : "";
            invite.last_name = name[1] ? name[1] : "";

            return invite;
        }
    },
    mounted() {
        document.body.classList.add("light",  "invisible");

        // Check if there is an invite token in the URL
        // TODO show a loader
        let token = this.token;
        if (token) {
            this.$ladder
                .read(`offers/${token}`)
                .then(res => {
                    store.setOffer(res);
                    this.offer = res;

                    // If this is not a coach offer or it's a public offer, send the user directly to the checkout page as there's nothing here to display.
                    if (!this.offer.coach || this.offer.is_public)
                        return this.$router.replace({name: 'Checkout'});
                     document.body.classList.remove("invisible");

                    this.loaded = true;
                    setTimeout(
                        () => this.$refs.header ? this.$refs.header.classList.add("animate") : null,
                        600
                    );
                })
                .catch(() => this.$router.replace("/"));
        } else {
            // If there is no invite token, redirect to the home page
            // TODO maybe show a message?
            this.$router.replace("/");
        }
    },
    beforeDestroy() {
        document.body.classList.remove("light", "invisible");
    }
};
</script>

<style lang="scss">
.header {
    overflow: hidden;
    position: relative;
    top: 0px;
    left: 0px;
    width: 100vw;
}
.logo-circle {
    background-color: #fff;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    display: block;
    line-height: 2.1rem;
    transition: all 300ms ease;
    opacity: 1;
}
header.collapsed {
    height: 7rem;
}
header.collapsed .logo-circle {
    height: 0px;
    width: 0px;
    max-height: 0px;
    padding: 0px !important;
    overflow: hidden;
    opacity: 0;
    margin-bottom: 0px !important;
    margin: 0px;
}

header.collapsed #header-content {
    font-size: 1rem;
    padding: 0rem 0;
}
header.collapsed h1 {
    font-size: 3rem;
}
header h1 {
    transition: all 300ms ease;
    margin-top: 4px;
    margin-bottom: 0px;
}

#background {
    width: 400vw;
    max-width: 400vw;
    overflow: hidden;
    transform: rotateZ(-25deg);
    transform-origin: top left;
    position: absolute;
    top: 0;
    left: -10vw;
    user-select: none;
    z-index: 1;
    transition: all 300ms ease;
    opacity: 0.75;
}
#background .bg-row {
    word-wrap: none;
    overflow: hidden;
    line-height: 4.5rem;
    height: 4.5rem;
    position: relative;
    opacity: 0;
    transition: all 2.2s cubic-bezier(0.25, 0.46, 0.285, 0.995) 10ms;
    transform: translateX(-1200px);
}
#background .bg-row:nth-child(odd) {
    transform: translateX(1200px);
}
.animate #background .bg-row {
    opacity: 1;
    transform: translateX(0px);
}
#background b {
    display: block;
    float: left;
    padding: 0 0.5rem;
    font-family: Druk;
    font-size: 4.5rem;
    color: $primary;
    opacity: 0.25;
    line-height: 4.5rem;
    letter-spacing: 0.05em;
    position: relative;
    transition: all 300ms linear;
    z-index: 1;
}
#background b:nth-child(5n + 1) {
    opacity: 0.25;
}
#background b:nth-child(5n + 2) {
    opacity: 0.75;
}
#background b:nth-child(5n + 3) {
    opacity: 0.5;
}
#background b:nth-child(5n + 4) {
    opacity: 0.25;
}
#background b:nth-child(5n + 5) {
    opacity: 0.5;
}
// #background b:hover {
//     opacity: 0.9 !important;
//     transform: scale(1.02, 1.02);
// }
#background b span {
    transition: all 300ms linear;
    color: $dark;
    text-shadow: -1px -1px 0 $primary, 1px -1px 0 $primary, -1px 1px 0 $primary,
        1px 1px 0 $primary;
}
#header-content {
    position: relative;
    z-index: 10;
    font-size: 1.125rem;
    padding: 2rem 0;
    transition: all 300ms ease;
}

.header-shadow {
    height: 1px;
    width: 100vw;
    box-shadow: 0px 0px 100px 50px rgba(0, 0, 0, 0.5);
    position: absolute;
    bottom: 0px;
    left: 0px;
    z-index: 8;
}

@media (max-width: #{map-get($grid-breakpoints, "sm")}) {
    .coach-name {
        font-size: 3rem;
    }
    #background {
        left: -30vw;
    }

    #background .bg-row {
        word-wrap: none;
        overflow: hidden;
        line-height: 3rem;
        height: 3rem;
        position: relative;
        opacity: 0;
        transition: all 1.8s cubic-bezier(0.25, 0.46, 0.285, 0.995);
        transform: translateX(-1200px);
    }
    #background b {
        display: block;
        float: left;
        padding: 0 0.25rem;
        font-family: Druk;
        font-size: 3rem;
        color: $primary;
        opacity: 0.4;
        line-height: 3rem;
        letter-spacing: 0.05em;
        position: relative;
        transition: all 300ms ease;
        z-index: 1;
    }

    #header-content {
        padding: 1rem;
    }
}
</style>
